module.exports = __webpack_public_path__ + "static/media/helengeli-38.3ece4dbc.jpg";